import { useState } from "react";

// Set in .env as REACT_APP_FORMSPREE_ID or replace below. Get your form ID at https://formspree.io/
const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID || "mzdjbnwk";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setStatus("loading");

    const formData = { name, email, message };

    if (FORMSPREE_ID === "YOUR_FORMSPREE_FORM_ID") {
      setStatus("success");
      setName("");
      setEmail("");
      setMessage("");
      return;
    }

    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus("success");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        const data = await res.json().catch(() => ({}));
        setStatus("error");
        setErrorMessage(data.error || "Something went wrong. Please try again or email directly.");
      }
    } catch {
      setStatus("error");
      setErrorMessage("Network error. Please try again or email directly.");
    }
  };

  return (
    <section id="contact" className="section" aria-labelledby="contact-heading">
      <h2 id="contact-heading">Contact Me</h2>
      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="contact-field">
          <label htmlFor="contact-name">Your Name</label>
          <input
            id="contact-name"
            type="text"
            name="name"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={status === "loading"}
            aria-required="true"
            autoComplete="name"
          />
        </div>
        <div className="contact-field">
          <label htmlFor="contact-email">Your Email</label>
          <input
            id="contact-email"
            type="email"
            name="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={status === "loading"}
            aria-required="true"
            autoComplete="email"
          />
        </div>
        <div className="contact-field">
          <label htmlFor="contact-message">Your Message</label>
          <textarea
            id="contact-message"
            name="message"
            placeholder="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            disabled={status === "loading"}
            aria-required="true"
          />
        </div>

        {status === "success" && (
          <p className="contact-status contact-status--success" role="status">
            Thanks. Your message has been sent. I&apos;ll get back to you soon.
          </p>
        )}
        {status === "error" && (
          <p className="contact-status contact-status--error" role="alert">
            {errorMessage}
          </p>
        )}

        <button type="submit" className="btn" disabled={status === "loading"}>
          {status === "loading" ? "Sending…" : "Send Message"}
        </button>
      </form>
      <div className="contact-info">
        <p>
          <i className="fas fa-envelope" aria-hidden="true" />{" "}
          <a href="mailto:abdullahimahad483@gmail.com">
            abdullahimahad483@gmail.com
          </a>
        </p>
        <p>
          <i className="fas fa-phone" aria-hidden="true" />{" "}
          <a href="tel:+447933080818">+447933080818</a>
        </p>
        <p>
          <i className="fas fa-map-marker-alt" aria-hidden="true" />{" "}
          <a
            href="https://www.google.com/maps/search/?api=1&query=London,UK"
            target="_blank"
            rel="noopener noreferrer"
          >
            London, UK
          </a>
        </p>
      </div>
    </section>
  );
};

export default Contact;
